export default __webpack_public_path__ + "assets/075e766329d5d4c81c3a1e5b57b8a87e.jpeg";